module.exports = __webpack_public_path__ + "media/images/page/estate_property_owners/img_04-d6fa98e64c62dc43f50465568f5b78ad.jpg";